export const UPDATE_CREATE_ACCOUNT_FORM = '@CREATE_ACCOUNT_FORM/UPDATE_CREATE_ACCOUNT_FORM'
